@if (hasWrapper()) {
    <div class="iframe-overlay"></div>
}
@if (content()) {
    <iframe #frame></iframe>
}
